Component({
  properties: {
    prop: {
      type: String,
      value: 'other.properties'
    },
  },
  data: {
    name: 'other',
  },
})
